import { LessonBasicResponse } from '../../mnspro-cloud/api/v2';
import { AgendaEntry } from '../../mnspro-cloud/classbook/AgendaEntry.interface';

export const lessonBasicResponseToAgendaEntry = (
  lesson: LessonBasicResponse,
): AgendaEntry => {
  return {
    classNames: lesson.classes.map(c => c.name),
    color: lesson.course.color,
    courseId: lesson.course.id,
    courseName: lesson.course.name,
    //TODO: Fix?
    lessonId: lesson.id,
    multiLessonId: lesson.multiLessonId,
    isPast: true,
    timeLabel: lesson.start,
  };
};
